module.exports = __webpack_public_path__ + "static/media/instituto8.10574e9b.svg";